'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OVERFLOW_WRAP = exports.OVERFLOW_WRAP = {
  NORMAL: 0,
  BREAK_WORD: 1
};

var parseOverflowWrap = exports.parseOverflowWrap = function parseOverflowWrap(overflow) {
  switch (overflow) {
    case 'break-word':
      return OVERFLOW_WRAP.BREAK_WORD;

    case 'normal':
    default:
      return OVERFLOW_WRAP.NORMAL;
  }
};